module.exports = __webpack_public_path__ + "img/ball.a51bc902.png";